import React from "react";

export const ShipmentRefundDetailContext = React.createContext(null);

export const useShipmentRefundDetailContext = () => {
    const context = React.useContext(ShipmentRefundDetailContext);

    if (!context) throw new Error("Shipment Refund Detail Context not provided!");

    return context;
};